<template>
  <div>
    <div class="rate-service rate-wrap rate-serv" :class="{'rated-hide': rateSent && rateSentDone, hide: isRejectedRate}">
        <div class="rate-wrap">
            <i class="close" @click="closeRate">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="#F1F4F6"/>
            </svg>
          </i>
          <p class="heading-rate">{{ $t('qic_insurance_success_rate_message') }}</p>
          <div class="rates">
            <label class="rate" for="negative">
              <input id="negative" type="radio" name="rate" @click="openRatePopup(0)">
              <img src="../assets/images/pensive-face.png" alt="pensive face">
            </label>
            <label class="rate" for="neutral" @click="openRatePopup(1)">
              <input id="neutral" type="radio" name="rate">
              <img src="../assets/images/neutral-face.png" alt="neutral face">
            </label>
            <label class="rate" for="smiling" @click="sendRate(2)">
              <input id="smiling" type="radio" name="rate">
              <img src="../assets/images/smiling-face.png" alt="smiling face">
            </label>
          </div>
        </div>
        <div class="thank-wrap">
          <p class="heading-rate">{{ $t('qic_insurance_success_rate_sent_thank') }}</p>
          <img class="ic" src="../assets/images/thumbs-up.png" alt="smiling face">
        </div>
    </div>

    <div class="popup popupSmall" v-show="ratePopupShow">  <!-- if only mobile - add class "visible-mobile"-->
      <div class="modalContent">
        <div class="closeBlock">
          <i class="close" @click="closeRatePopup()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="#526C82" fill-opacity="0.8"/>
            </svg>
          </i>
        </div>
          <div class="groupRate">
            <button type="button" @click="setRate(0)">
              <img src="../assets/images/foldedhand.png" alt="foldedhand">
            </button>
          </div>
          <form @submit.prevent="popupSend()">
            <div class="modal_titleForm">{{ $t('qic_insurance_success_rate_popup') }}</div>
            <div class="container-textarea">
              <textarea class="textareaForm" placeholder=" " v-model="rateMessage"></textarea>
              <label for="rateMessage">{{ $t('qic_insurance_success_rate_placeholder') }} </label>
            </div>
            <button class="btn" type="submit" :disabled="rateSent">
              {{ $t('qic_send') }}
            </button>
          </form>
      </div>
    </div> <!-- popup -->
    <div class="popup popupSmall" v-show="rateSentPopupShow">  <!-- if only mobile - add class "visible-mobile"-->
      <div class="modalContent">
        <div class="closeBlock">
        <i class="close" @click="closeRateSentPopup()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z" fill="#526C82" fill-opacity="0.8"/>
          </svg>
        </i>
        </div>
        <div class="acceptModal">
          <div class="modal_titleForm">{{ $t('qic_thank_you') }}
            <p>{{ $t('qic_insurance_success_rate_sent_popup') }}</p>
          </div>
          <button class="btn btnAccept" type="button" @click="closeRateSentPopup()">
            {{ $t('qic_ok') }}
          </button>
        </div>
      </div>
    </div> <!-- popup -->
    <div class="bgPopup" v-show="popupBgShow" @click="closePopup()"></div> <!-- if only mobile - add class "visible-mobile"-->
  </div>
</template>

<script>
export default {
  name: 'RateService',
  computed: {
    popupBgShow () {
      return this.ratePopupShow || this.rateSentPopupShow
    }
  },
  data () {
    return {
      rate: null,
      ratePopupShow: false,
      rateSentPopupShow: false,
      rateMessage: '',
      rateSent: false,
      rateSentDone: false,
      isRejectedRate: false
    }
  },
  methods: {
    openRatePopup (rate) {
      this.setRate(rate)
      this.ratePopupShow = true
    },
    closeRatePopup () {
      this.setRate(null)
      this.ratePopupShow = false
    },
    openRateSentPopup () {
      this.rateSentPopupShow = true
    },
    closeRateSentPopup () {
      this.rateSentPopupShow = false
      if (this.rateSent) {
        setTimeout(() => {
          this.rateSentDone = true
        }, 1000)
      }
    },
    setRate (rate) {
      this.rate = rate
    },
    closeRate () {
      this.isRejectedRate = true
    },
    popupSend () {
      this.sendRateImpl()
      this.openRateSentPopup()
      this.closeRatePopup()
    },
    sendRate (newRate) {
      this.sendRateImpl(newRate)
        .then(() => {
          this.rateSentDone = true
        })
    },
    sendRateImpl (newRate) {
      const rate = newRate || this.rate
      const rateMessage = this.rateMessage || ''
      this.rateSent = true
      try {
        return this.$store.dispatch('sendInsuranceRate', {
          rate,
          rateMessage
        })
      } catch {
        return Promise.resolve()
      }
    },
    closePopup () {
      this.closeRatePopup()
      this.closeRateSentPopup()
    }
  }
}
</script>
<style lang="scss" scoped>
.rate-service .close {
    cursor: pointer;
    right: 16px;
    top: 16px;
    opacity: .5;
    position: absolute;
}
.rate-service .close:hover{
  opacity: 1;
}
.rate-service {
  padding: 24px;
  transition: 1s;
  width: 100%;
  max-width: 352px;
  background: rgba(0, 0, 0, 0.75);
  border-radius: 32px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;
  bottom: 40px;
  left: 0;
  right: 0;
  z-index: 33;
  padding-top: 40px;
  .title {
    width: 100%;
    font-family: 'Izmir-Medium';
    margin-bottom: 24px;
    body.rtl & {
      font-family: 'URWGeometricArabic-Medium';
    }
  }
  .rates {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    text-align: center;
    width: 100%;
    position: relative;
    transition: .3s;
    margin: auto;
    justify-content: space-around;
    .item {
      margin: 0 20px;
    }
    .rate {
      cursor: pointer;
      position: relative;
      transition: .3s;
      padding: 8px;
      border-radius: 10px;
      &:hover{
        background: rgba(255, 255, 255, 0.1);
      }
      input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
        opacity: 0;
        margin: auto;
        cursor: pointer;
      }
      img {
        width: 32px;
        height: 32px;
        object-fit: contain;
        display: block;
        margin: auto;
      }
    }
  }
  .ic {
    width: 40px;
    height: 40px;
    margin: 0;
  }
  .thank-wrap {
    display: none;
    .title {
      white-space: nowrap;
    }
  }
  &.rated-hide {
    padding: 0;
    transition: 1.4s;
    overflow: hidden;
    opacity: 0;
    animation: remove 1500ms linear;

    .rate-wrap {
      animation: close 300ms ease-in-out;
      width: 0;
      height: 0;
      overflow: hidden;

      .rates {
        width: 40px;
        height: 40px;
        margin: auto;

        .rate {
          position: absolute;
          left: 0;
          right: 0;
          margin: auto;
          top: 0;
          bottom: 0;

          &:nth-child(1) {
            right: auto;
            left: 0;
          }

          &:nth-child(2) {
            right: auto;
            left: auto;
          }

          &:nth-child(3) {
            right: 0;
            left: auto;
          }
        }
      }
    }

    .thank-wrap {
      display: block;
      animation: show 300ms ease-in-out;
    }
  }
  &.hide {
    min-height: 176px;
    transition: 1.4s;
    overflow: hidden;
    opacity: 0;
    animation: reject 1500ms linear;

    .heading-rate {
      max-width: 95%;
      margin: 0 auto 16px auto;
      text-align: center;
    }

    .thank-wrap {
      display: none;
    }
  }

  @media (max-width: 767px) {
    width: 100%;
    bottom: 0;
    left: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    .title {
      font-size: 15px;
      line-height: 20px;
      margin-bottom: 16px;
    }
  }
  @media (max-width: 550px) {
    padding-bottom: 56px;
  }
}
@keyframes show {
  0% {
    width: 0;
    height: 0;
    overflow: hidden;
  }
  100% {
    width: auto;
    height: auto;
  }
}

@keyframes close {
  0% {
    width: auto;
    height: auto;
  }
  100% {
    width: 0;
    height: 0;
    overflow: hidden;
  }
}

@keyframes reject {
  0% {
    width: auto;
    height: auto;
    padding: 40px 24px 24px;
  }
  75% {
    width: auto;
    height: auto;
    padding: 40px 24px 24px;
  }
  100% {
    width: 0;
    height: 0;
    overflow: hidden;
  }
}

@keyframes remove {
  0% {
    width: auto;
    height: auto;
    padding: 16px 16px 24px;
  }
  75% {
    width: auto;
    height: auto;
    padding: 16px 16px 24px;
  }
  100% {
    width: 0;
    height: 0;
    overflow: hidden;
  }
}
</style>
